import { useState, useRef, ReactElement } from 'react';
import { Popover as TinyPopover } from 'react-tiny-popover';
import { useEventListener } from 'usehooks-ts';
import { Transition } from '@headlessui/react';

/**
 * Display a popover (tooltip) when the child is hovered.
 */
export function Popover({
  children,
  content,
}: {
  children: ReactElement;
  /**
   * Content of the popover (tooltip).
   */
  content: string | ReactElement;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const childRef = useRef(null);

  useEventListener('mouseover', () => setIsOpen(true), childRef);
  useEventListener('mouseout', () => setIsOpen(false), childRef);

  // append to main layout to get font styles
  const parentEl =
    typeof document === 'undefined'
      ? undefined
      : (document.getElementById('__next')?.firstChild as HTMLElement);

  return (
    <>
      <TinyPopover
        isOpen={isOpen}
        parentElement={parentEl}
        containerClassName="z-5"
        content={
          <Transition
            show={isOpen}
            enter="transition ease-in duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-out duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className="z-5 max-w-xs rounded border border-gray-400 bg-white py-1 px-2 font-header text-sm shadow-lg"
          >
            {content}
          </Transition>
        }
        ref={childRef}
      >
        {children}
      </TinyPopover>
    </>
  );
}
